import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import TVPng from "../../../../resources/images/png/home/TV.png";
import { ReactComponent as TVBackground } from "../../../../resources/images/svg/home/tvBackground.svg";
import InexCard from "../../../InexCard";
import { CardGiftcardRounded } from "@mui/icons-material";
import { CTAButton } from "../odyssee/OdysseeCard";
import { Description, DigitalImage, PriceContainer, Title } from "./DigitalBlock";
import { useIsMobile } from "../../../../hooks/responsive";

const TVBlock = ({}) => {
	const isMobile = useIsMobile();

	const link = "https://abonnements.inexplore.com/offrir?selectedAbos=[2]";

	return (
		<InexCard
			sx={{
				position: "relative",
				paddingTop: 0,
				paddingBottom: 0,
				padding: 0,
				boxShadow: (theme) => theme.shadows[26],
				zIndex: 0,
			}}
		>
			<TVBackground
				style={{
					position: "absolute",
					left: 0,
					height: "100%",
				}}
			/>
			<Grid
				container
				sx={{
					background: "linear-gradient(90deg, #21639E 0%, #6C3490 100%)",
					zIndex: 1,
				}}
			>
				<Grid item xs={3}>
					<Box
						sx={{
							position: "relative",
							width: "100%",
							height: "100%",
							minHeight: "150px",
							overflow: "hidden",
						}}
					>
						<DigitalImage
							src={TVPng}
							alt="Digital Png"
							style={{
								transform: "translate(0%, 5%)",
							}}
						/>
					</Box>
				</Grid>
				<Grid
					item
					xs={9}
					sm={6}
					md={7}
					sx={{
						zIndex: 1,
					}}
				>
					<Box
						pl={isMobile ? 2 : 0}
						pt={4}
						pb={4}
						sx={{
							display: "flex",
							justifyContent: "center",
							flexDirection: "column",
							height: "100%",
						}}
					>
						<Title
							sx={{
								color: "white",
							}}
						>
							Inexploré TV + digital
						</Title>
						<Description
							sx={{
								color: "white",
							}}
						>
							Offrez un abonnement de 6 mois à la plateforme Inexploré TV pour voir les documentaires, les
							séries, les émissions et les événements en vidéo + tout l’univers Inexploré digital
						</Description>
						{!isMobile && (
							<Box
								sx={{
									marginTop: (theme) => theme.spacing(1),
								}}
							>
								<a target="_blank" href={link}>
									<CTAButton
										variant={"texticon"}
										icon={
											<CardGiftcardRounded
												sx={{
													fontSize: "26px",
													color: (theme) => theme.palette.secondary.main,
												}}
											/>
										}
										textWithGradient={false}
										disableBackground={true}
										text={"Offrir une carte cadeau Inexploré TV + digital"}
										sx={{
											minWidth: 230,
											padding: 3.5,
											flexDirection: "row-reverse",
											backgroundColor: "#F1C555",
										}}
										textSx={{
											textTransform: "none",
										}}
									/>
								</a>
							</Box>
						)}
					</Box>
				</Grid>
				<Grid
					xs={12}
					sm={3}
					md={2}
					sx={{
						zIndex: 1,
					}}
				>
					<PriceContainer
						sx={{
							marginTop: isMobile ? 0 : "20px",
						}}
					>
						<Typography
							sx={{
								fontSize: "16px",
								fontFamily: "Branding Semibold",
								color: "white",
							}}
						>
							6 mois d'abonnement
						</Typography>
						<Typography
							sx={{
								fontSize: "30px",
								fontFamily: "Branding Bold",
								color: "white",
							}}
						>
							59,00€
						</Typography>
					</PriceContainer>
				</Grid>
				{isMobile && (
					<Grid
						xs={12}
						m={2}
						sx={{
							zIndex: 1,
						}}
					>
						<Box
							sx={{
								marginTop: (theme) => theme.spacing(1),
							}}
						>
							<a target="_blank" href={link}>
								<CTAButton
									variant={"texticon"}
									icon={
										<CardGiftcardRounded
											sx={{
												fontSize: "26px",
												color: (theme) => theme.palette.secondary.main,
											}}
										/>
									}
									textWithGradient={false}
									disableBackground={true}
									text={"Offrir une carte cadeau Inexploré TV + digital"}
									sx={{
										width: "100%",
										minWidth: 230,
										padding: 3.5,
										flexDirection: "row-reverse",
										backgroundColor: "#F1C555",
									}}
									textSx={{
										textTransform: "none",
									}}
								/>
							</a>
						</Box>
					</Grid>
				)}
			</Grid>
		</InexCard>
	);
};

export default TVBlock;
